<template>
  <div class="">
    <div class="mapStyle" id="map">
    </div>
    <div id="mapHeaderIcon">
      <img src="assets/ASCP-New-Logo.svg" class="mapIcon" height="50px"/>
    </div>
    <MapComponent id="legend" inputClass="overlay-tr">
      <template slot="header">
        <h4>Legend</h4>
      </template>
      <template slot="body">
        <table class="table table-sm table-borderless m-0">
          <tbody>
            <tr class="pt-0 pb-0">
              <td><b-img src="assets/PCP32.png"  height="30" alt="Responsive image" /></td>
              <td class="">PCP</td>
            </tr>
            <tr>
              <td><b-img src="assets/JRCP32.png" height="30" alt="Responsive image" /></td>
              <td>JRCP</td>
            </tr>
            <tr>
              <td><b-img src="assets/CRCP32.png" height="30" alt="Responsive image" /></td>
              <td>CRCP</td>
            </tr>
            <tr>
              <td><b-img src="assets/NONE32.png" height="30" alt="Responsive image" /></td>
              <td>None</td>
            </tr>
          </tbody>
        </table>
      </template>
    </MapComponent>
    <div id="popup" class="ol-popup container">
      <!-- <a href="#" id="popup-closer" class="ol-popup-closer"></a> -->
      <dl id="popup-content" class="col-12">
        <template v-if="popupData.project_name">
          <dt>Name</dt>
          <dd>{{popupData.project_name}}</dd>
        </template>
        <template v-if="popupData.contractor">
          <dt>Contractor</dt>
          <dd>{{popupData.contractor}}</dd>
        </template>
        <template v-if="popupData.pavement_type">
          <dt>Pavement</dt>
          <dd>{{popupData.pavement_type}}</dd>
        </template>
        <template v-if="popupData.state">
          <dt>State</dt>
          <dd>{{popupData.state}}</dd>
        </template>
        <template v-if="popupData.suburb">
          <dt>Suburb</dt>
          <dd>{{popupData.suburb}}</dd>
        </template>
      </dl>
    </div>
  </div>
</template>

<script>
import 'ol/ol.css'
import Map from 'ol/Map';
import {fromLonLat} from 'ol/proj'
import View from 'ol/View';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import {Cluster, OSM, Vector as VectorSource} from 'ol/source.js';
import {Circle as CircleStyle, Fill, Stroke, Style, Icon, Text} from 'ol/style.js';
import Overlay from 'ol/Overlay.js';
import OverviewMap from 'ol/control/OverviewMap';
import ScaleLine from 'ol/control/ScaleLine';
import Attribution from 'ol/control/Attribution';
import Zoom from 'ol/control/Zoom';
import Rotate from 'ol/control/Rotate';
import Control from 'ol/control/Control';
import MapComponent from './../PavementBody/MapComponent.vue'
import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';

export default {
  name: "Map",
  components: {
    MapComponent
  },
  props: {
    generateMapFlag: Boolean,
    geoJsonData: Object
  },
  data() {
    return {
      map: {},
      popupData: {
        contractor: "",
        dc: "",
        pavement_type: "",
        postcode: "",
        project_name: "",
        state: "",
        suburb: "",
        year_paved: ""
      },
      pointImage: {
        'PCP': new Style({
          image: new Icon({
            src: 'assets/PCP32.png'
          })
        }),
        'JRCP': new Style({
          image: new Icon({
            src: 'assets/JRCP32.png'
          })
        }),
        'CRCP': new Style({
          image: new Icon({
            src: 'assets/CRCP32.png'
          })
        }),
        "NONE": new Style({
          image: new Icon({
            src: 'assets/NONE32.png'
          })
        }),
      },
      styleCache: {},
      pavementType: ""
    }
  },
  mounted() {
    const current = this
    var container = document.getElementById("popup")
    var content = document.getElementById("popup-content")
    var closer = document.getElementById('popup-closer');
    var legend = document.getElementById('legend');
    var header = document.getElementById('mapHeaderIcon');
    var refreshButton = document.getElementById('refreshButton');
    var overlay = new Overlay({
      element: container,
      autoPan: true,
      autoPanAnimation: {
        duration: 250
      }
    });

    var mapLegend = new Control({element: legend});
    var mapHeader = new Control({element: header});
    var refreshButton = new Control({element: refreshButton});

    console.log(mapLegend);
    var view = new View({
      center: fromLonLat([151.2093, -33.8688]),
      zoom: 6,
      minZoom: 4,
      maxZoom:12,
      projection: "EPSG:3857"
    })
    this.map = new Map({
      layers: [
        new TileLayer({
          source: new OSM({
            // Need to check for production
            url: "https://api.mapbox.com/v4/mapbox.streets/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoicXVpbmVzbGEiLCJhIjoiY2pzOW16NmthMHo4bTQ0bGlic3VjZGtsdyJ9.ggMkRs_gY9KGy3IiPcmkxw"
          })
        }),
      ],
      overlays: [overlay],
      view: view,
      target: "map",
      controls: [
        new OverviewMap,
        new ScaleLine,
        new Zoom,
        new Rotate,
        new Attribution,
        mapLegend,
        mapHeader,
        refreshButton
      ]
    })
    this.map.on('click', (event)=>{
      this.resetPopup(overlay);
      const current = this
      var pixelFeatures = current.map.getFeaturesAtPixel(event.pixel);
      // console.log(pixelFeatures);
      var coordinate = event.coordinate
      if (typeof pixelFeatures == "object" && pixelFeatures && pixelFeatures.length > 0) {
        // console.log(pixelFeatures);

        pixelFeatures.forEach(item=>{
          Object.keys(item.values_).filter(key=>key != "geometry").forEach(key=>{
            var pixelFeature = item.values_.features
            // console.log(pixelFeature);
            if(pixelFeature.length == 1){
              pixelFeature.forEach(item=>{
                Object.keys(item.values_).filter(key=>key != "geometry").forEach(key=>{
                  current.popupData[key] = item.values_[key]
                })
              })
              overlay.setPosition(coordinate);
            }
            else {
              current.popupData = {
                contractor: "",
                dc: "",
                pavement_type: "",
                postcode: "",
                project_name: "",
                state: "",
                suburb: "",
                year_paved: ""
              }
              overlay.setPosition(undefined);
            }
          })
        })
        // overlay.setPosition(coordinate);
      }
    })
  },
  watch: {
    geoJsonData: function () {
      var layerKey = "customGeoJson";
      var currentLayers = this.map.getLayers()
      var layerTypes = ["PCP","JRCP","CRCP","NONE"];
      // console.log(this.map.removeLayers(currentLayers.array_.filter(obj=>obj.values_.layerGroupId==layerKey)));

      currentLayers.array_.filter(obj=>obj.values_.layerGroupId==layerKey).forEach(item=>{
        console.log(this.map.removeLayer(item));
      })
      layerTypes.forEach(layerType=>{
        if (typeof this.geoJsonData[layerType] != "undefined" && typeof this.geoJsonData[layerType].type != "undefined") {
          var geoJson =  new GeoJSON()
          var featureCollection = new VectorSource({
            features: geoJson.readFeatures(this.geoJsonData[layerType],
              {featureProjection: "EPSG:3857"}
            ),
          });

          var clusterSource = new Cluster({
              distance: 40,
              source: featureCollection
          });

          this.pavementType = layerType
          // console.log(layerType);
          // console.log(clusterSource);

          // console.log(this.styleFunction);
          this.styleCache = {}
          var vectorLayer = new VectorLayer({
            source: clusterSource,
            style: this.styleFunction
          });

          vectorLayer.set("layerGroupId",layerKey, true);
          vectorLayer.set("layerId", layerType, true);
          this.map.addLayer(vectorLayer);
          this.map.render();
        }
      })
    },

  },
  methods: {
    styleFunction: function(feature) {
      // console.log(this.pavementType);
      var size = feature.get('features').length;
      var style = this.styleCache[size];

      if(size > 1){
        if (!style) {
          style = this.pointImage[this.pavementType];
          // style = new Style({
          //   image: new CircleStyle({
          //     radius: 10,
          //     stroke: new Stroke({
          //       color: '#fff'
          //     }),
          //     fill: new Fill({
          //       color: '#3399CC'
          //     })
          //   }),
          //   text: new Text({
          //     text: size.toString(),
          //     fill: new Fill({
          //       color: '#fff'
          //     })
          //   })
          // });
          this.styleCache[size] = style;
        }
        return style;
      }
      else {
        return this.pointImage[feature.get('features')[0].values_.pavement_type?feature.get('features')[0].values_.pavement_type:"NONE"];
      }

    },
    pixelClicked: function(feature, layer) {
      // this will hold the pop-over show display, might need to import OL Overlay to handle
      console.log(feature);
      console.log(layer);
    },
    resetPopup: function(overlay) {
      overlay.setPosition(undefined);
    }
  }
}
</script>

<style lang="css">
  .mapStyle {
    min-height: 900px!important;
  }
  .mapIcon {
    position: absolute;
    top: 12px;
    left: 3em;
  }
  .refreshButton {
    position: absolute;
    top: 5em;
    left: 0.7em;
  }
  .ol-popup {
    position: absolute;
    background-color: white;
    -webkit-filter: drop-shadow(0 1px 4px rgba(0,0,0,0.2));
    filter: drop-shadow(0 1px 4px rgba(0,0,0,0.2));
    padding: 15px;
    border-radius: 10px;
    border: 1px solid #cccccc;
    bottom: 12px;
    left: -50px;
    min-width: 280px;
  }
  .ol-popup:after, .ol-popup:before {
    top: 100%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  .ol-popup:after {
    border-top-color: white;
    border-width: 10px;
    left: 48px;
    margin-left: -10px;
  }
  .ol-popup:before {
    border-top-color: #cccccc;
    border-width: 11px;
    left: 48px;
    margin-left: -11px;
  }
  .ol-popup-closer {
    text-decoration: none;
    position: absolute;
    top: 2px;
    right: 8px;
  }
  .ol-popup-closer:after {
    content: "✖";
  }

  .ol-scale-line {
    position: absolute;
    left: 112em;
    bottom: 2em;
  }
</style>
